import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Berita from "./Berita";
import Footer from "./footer";
import Cta from "./CtaBerita";

const News=()=>{
    return(
        <div className="page-berita">        
        <Helmet>
        <title>News | Mirai Akademi</title>
        </Helmet>

            <Cta />
            <Berita />
            <Footer />
        
        </div>
    )
}


export default News;